import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import { AppLayout } from '@/dmdrive/core/constants/layout';
import { useStore } from '@/dmdrive/store';
import { useTopicStore } from '@/dmdrive/topic/components/Topic/TopicStore';

import { CloseLeftSidebar, LeftSidebarContent, LeftSidebarRoot } from './LeftSidebar.styles';

import Histogram from './Histogram/Histogram';
import ModelsList from './ModelsList/ModelsList';
import Recognition from './Recognition/Recognition';
import Snapshots from './Snapshots/Snapshots';
import Visualisation from './Visualization/Visualization';

function LeftSidebar() {
  const { layout } = useStore('appStore');
  const { isLeftSidebarOpen, toggleLeftSidebar } = useTopicStore();
  const [recognitionKey] = useState(0);

  return (
    <LeftSidebarRoot layout={layout} isOpen={isLeftSidebarOpen}>
      {layout === AppLayout.Mobile && isLeftSidebarOpen && (
        <CloseLeftSidebar onClick={() => toggleLeftSidebar(false)}>
          <CloseIcon />
        </CloseLeftSidebar>
      )}

      <LeftSidebarContent>
        <ModelsList />

        <Visualisation />

        <Recognition key={recognitionKey} />

        <Histogram />

        <Snapshots />
      </LeftSidebarContent>
    </LeftSidebarRoot>
  );
}

export default observer(LeftSidebar);
